// Version : 1.0.0
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import PhotoVerificationActionType from './photo-verification.types';
import {
	addMemberPhotoSuccess,
	addMemberPhotoFailure,
	addMemberPhotoUserResponseChanged,
} from './photo-verification.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { memberPhotoAdd } from './photo-verification.service';

/** ***************** Member Photo Add Start ************************/
export function* AddMemberPhoto({ payload }: any) {
	try {
		const key = 'AddMemberPhotoVerification';
		const { companyID, databaseName, memberID, memberProfileImg, docType, userID } = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			MemberPhoto: memberProfileImg,
			DocumantType: docType,
			OfficerID: userID,
			Secratekey: key,
		};
		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberPhotoAdd, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addMemberPhotoFailure(responseData.data));
		} else {
			yield put(addMemberPhotoSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addMemberPhotoFailure(error));
	}
}

export function* AddMemberPhotoResponseClear() {
	yield put(addMemberPhotoUserResponseChanged());
}

export function* onAddMemberPhotoStart() {
	yield takeLatest(PhotoVerificationActionType.ADD_MEMBER_PHOTO_START, AddMemberPhoto);
}

export function* onAddMemberPhotoResponseReset() {
	yield takeLatest(
		PhotoVerificationActionType.ADD_MEMBER_PHOTO_RESPONSE_REST_START,
		AddMemberPhotoResponseClear,
	);
}
/** ***************** Member Photo Add End ************************/

export function* addMemberPhotoSaga() {
	yield all([call(onAddMemberPhotoStart), call(onAddMemberPhotoResponseReset)]);
}
